<template>
  <BaseMenu v-bind="$attrs" drop-down-width="xxs">
    <template #default="{ isVisible }">
      <BaseButton
        look="none"
        justify="start"
        class="hover:bg-ocean transition duration-150 ease-in-out !px-2 sm:!px-5 bg-white"
        rounded="xl"
      >
        <div class="mr-1 sm:mr-3 font-normal">
          {{ title }}
        </div>
        <BaseIcon
          class="text-primary"
          name="outline_chevron_down"
          :class="isVisible && 'rotate-180'"
          size="md"
        />
      </BaseButton>
    </template>
    <template #menu>
      <div
        class="bg-white p-4 rounded-xl shadow-lg mt-2 max-h-[350px] overflow-auto"
        :class="proxyWidth"
      >
        <slot />
      </div>
    </template>
  </BaseMenu>
</template>

<script setup lang="ts">
const menuWidth = {
  xs: 'min-w-[120px] sm:min-w-[180px]',
  md: 'min-w-[180px] sm:min-w-[280px]',
  xl: 'min-w-[200px] sm:min-w-[320px]',
} as Record<string, string>

interface Props {
  title: string
  width?: keyof typeof menuWidth
}

const props = defineProps<Props>()

const proxyWidth = computed(() => {
  return (props.width && menuWidth[props.width]) || menuWidth.md
})
</script>
